module.exports = __webpack_public_path__ + "static/media/yoda-logo.df169809.png";